<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span
      class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide"
    >Type:</span>
    <div class="wf-w-1/2">
      <select v-model="galleryType" class="wf-w-full">
        <option
          :key="typeOption.value"
          v-for="typeOption in typeOptions"
          :value="typeOption.value"
          v-text="typeOption.text"
        ></option>
      </select>
    </div>
  </li>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      typeOptions() {
        return [
          {value: 'grid', text: 'Grid'},
          {value: 'masonry', text: 'Masonry'},
          {value: 'slider', text: 'Slider'}
        ]
      },
      galleryType: {
        get() {
          return 'grid'
        },
        set(value) {
          this.addToObject(this.module, { type: value}, 'content', null, {}, true, this.parentModule)
        }
      },
    }
  })
</script>
